module.exports = __webpack_public_path__ + "static/media/img-destaque-home.9ed8070b.jpg";